
import type { AppMessage } from '../../types/message'

export const useMessage = defineStore('toast', () => {
    const toasts = ref<AppMessage[]>([]);

    const add = (
        message: string,
        type: 'success' | 'error' = 'success',
        autoRemove = true,
        duration = 3000
    ) => {
        const { $i18n } = useNuxtApp();
        const id = Date.now();
        let finalMessage = "";

        if (type === 'error') {
            const defaultError = $i18n.t('messages.unknown_error');

            // 1. Check if it's a valid i18n key
            if ($i18n.te(`messages.${message}`)) {
                finalMessage = $i18n.t(`messages.${message}`);
            }
            // 2. If not a key, use the raw string provided (err.message/statusMessage)
            else if (message) {
                finalMessage = message;
            }
            // 3. Fallback to default
            else {
                finalMessage = defaultError;
            }
        } else {
            // Success logic: translate if key exists, otherwise keep empty
            finalMessage = $i18n.te(`messages.${message}`) ? $i18n.t(`messages.${message}`) : message;
        }

        toasts.value.push({
            id,
            message: finalMessage,
            type,
            autoRemove,
            duration
        });

        if (autoRemove) {
            setTimeout(() => remove(id), duration);
        }
    };

    const error = (err: any, autoRemove = true, duration = 3000) => {
        const localeMessage = err?.data?.code;
        const fallback = err.message || err.data?.statusMessage || "";

        add(localeMessage || fallback, 'error', autoRemove, duration);
    };

    const remove = (id: number) => {
        toasts.value = toasts.value.filter(t => t.id !== id);
    };

    return { toasts, add, error, remove };
});